import React from 'react'
import styles from './TeamListFooter.m.sass'
import Button from 'components/Button'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onCreateClick: () => void
}

export default function TeamListFooter({ onCreateClick }: Props) {
  return (
    <div className={styles.root}>
      <div className={styles.text}>
        Need a new team?{' '}
        <Button onClick={() => onCreateClick()} type="text">
          Create Team
        </Button>
      </div>
    </div>
  )
}
